module.exports = __webpack_public_path__ + "img/事项清单.89efc2c4.svg";